import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersearchService {

  private searchTextSource = new BehaviorSubject<string>('');
  searchText$ = this.searchTextSource.asObservable();

  setSearchText(text: string) {
    this.searchTextSource.next(text ?? '');
  }

  getSearchText(): string {
    return this.searchTextSource.getValue() ?? '';
  }
}
